import type { ModuleRouteNames } from '../moduleRouteNames'
import type { RvaiRouteRecord } from '../types'
import { routes as aboutRoutes } from './about'
import { routes as cameraManagementRoutes } from './cameraManagement'
import { routes as classesRoutes } from './classes'
import { routes as membersRoutes } from './members'
import { routes as monitoringRoutes } from './monitoring'
import { routes as pluginsRoutes } from './plugins'
import { routes as projectsRoutes } from './projects'
import { routes as resourcesRoutes } from './resources'
import { routes as settingsRoutes } from './settings'
import { routes as topologyRoutes } from './topology'


export const moduleRoutes: RvaiRouteRecord<ModuleRouteNames>[] = [
  aboutRoutes,
  cameraManagementRoutes,
  classesRoutes,
  // datapoolsRoutes,
  monitoringRoutes,
  membersRoutes,
  // modelsRoutes,
  pluginsRoutes,
  projectsRoutes,
  resourcesRoutes,
  settingsRoutes,
  topologyRoutes,
]
